export default [
  {
    path: "/teacher",
    name: "teacher",
    component: () => import("@/views/teacher/index.vue"),
    meta: {
      title: "师资团队"
    }
  }
];
